import React from 'react'
import InnerHTML from 'dangerously-set-html-content'
import { Modal } from '../../admin/Modal'
import styled from 'styled-components'

const HubspotForm = ({ cta, product, toggle }) => {
  const html = cta.hubspot_form
  const TopBarComponent = (
    <TopBarWrapper>
      <div>
        <h4>{product.product_name}</h4>
      </div>
    </TopBarWrapper>
  )
  return (
    <Modal
      visible={true}
      toggle={toggle}
      TopBarComponent={TopBarComponent}
      topBarColor="#f7f8fa"
    >
      <Wrapper>
        <InnerHTML html={html} />
      </Wrapper>
    </Modal>
  )
}

export default HubspotForm

const TopBarWrapper = styled.div`
  display: flex;
  gap: 15px;
  padding: 20px;
  h4 {
    font-size: 20px;
    color: ${(props) => props.theme.colors.black};
  }
  p {
    color: ${(props) => props.theme.colors.black};
  }
`

const Wrapper = styled.div`
  padding: 20px;
`
